import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { useNavigation } from "@react-navigation/native";

interface HomeIdentityItemProps {
  item: {
    id: string;
    nama: string;
    gender: string;
    ttl: string;
    alamat: string;
  };
}

const HomeIdentity = ({ item }: HomeIdentityItemProps) => {
  const navigation = useNavigation();

  const detail = () => {
    console.log("details");
    navigation.navigate("AllIdentity");
  };

  return (
    <TouchableOpacity onPress={detail}>
      <View>
        <Text style={styles.homeIdentityName}>
          {item.nama} <span>({item.gender === "Laki-Laki" ? "L" : "P"})</span>
        </Text>
        <Text style={styles.homeIdentityBirth}>{item.ttl}</Text>
        <Text style={styles.homeIdentityAddress}>{item.alamat}</Text>
      </View>
    </TouchableOpacity>
  );
};

export default HomeIdentity;

const styles = StyleSheet.create({
  homeIdentityName: {
    fontSize: 24,
    fontWeight: "500",
  },
  homeIdentityBirth: {
    fontSize: 16,
    fontWeight: "500",
    marginVertical: 5,
  },
  homeIdentityAddress: {
    fontSize: 16,
    fontWeight: "500",
  },
});
